// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValidateEmailSetup_error_message__2C-ry {
  color: var(--color-theme-red);
}

.ValidateEmailSetup_loading_container__oDRe4 .MuiCircularProgress-root {
  display: block;
  margin: 20px auto;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ValidateEmailSetupPopup/ValidateEmailSetup.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".error_message {\n  color: var(--color-theme-red);\n}\n\n.loading_container :global(.MuiCircularProgress-root) {\n  display: block;\n  margin: 20px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error_message": `ValidateEmailSetup_error_message__2C-ry`,
	"loading_container": `ValidateEmailSetup_loading_container__oDRe4`
};
export default ___CSS_LOADER_EXPORT___;
